import { Injectable } from '@angular/core';
import { CustomerContactModel } from '@app/pages/invoice/models/customer-contacts';
import { CustomerCreationModel } from '@app/pages/invoice/models/invoice-creation';
import  moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Api } from './api.service';
import { BaseService } from './base.service';

@Injectable()
export class InvoiceService extends BaseService {
  controllerName = 'api/invoice';

  constructor(protected api: Api) {
    super(api, 'api/invoice');
  }

  getInvoiceByDeliveryId(id: number): Observable<{ data: string }> {
    return this.api.get(`${this.controllerName}/get-by-delivery-id/${id}`);
  }

  getInvoicePdfById(id: number): Observable<string> {
    return this.api.get(`${this.controllerName}/get-pdf/${id}`);
  }

  getById(id: number) {
    return this.api.get(`${this.controllerName}/${id}`);
  }

  resendInvoice(id, selectedContacts: Array<CustomerContactModel>) {
    return this.api.post(
      `${this.controllerName}/${id}/resend-invoice`,
      selectedContacts
    );
  }

  create(data: CustomerCreationModel) {
    return this.api.post(`${this.controllerName}`, data);
  }

  getInvoiceDeliverySchedule(customerId: number, invoiceDate: Date) {
    const params: any = {
      invoiceDate: invoiceDate, // MM/dd/yyyy
    };
    return this.api.get(
      `${this.controllerName}/get-delivery-schedules/${customerId}`,
      params
    );
  }
}
